<ng-container *ngIf="loading; else elseTemplate">
  <div class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <form [formGroup]="requestFormGroup" (ngSubmit)="addNewHardwareSoftware()">
    <div class="row">
      <div class="col">
        <h4 style="margin-top: 0px;">{{'request-event-modal.software' | translate}}</h4>
        <div class="row">
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.waiters' | translate"
              [formGroup]="requestFormGroup" formControlNameValue="waiters" formGroupNameValue="softwares"
              name="waiters" id="waiters">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.cash-register' | translate"
              [formGroup]="requestFormGroup" formControlNameValue="cashRegister" formGroupNameValue="softwares"
              name="cashRegister" id="cashRegister">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.main-device' | translate"
              [formGroup]="requestFormGroup" formControlNameValue="mainDevice" formGroupNameValue="softwares"
              name="mainDevice" id="mainDevice">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.printers' | translate"
              [formGroup]="requestFormGroup" formControlNameValue="printers" formGroupNameValue="softwares"
              name="printers" id="printers">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.fiscalPrinters' | translate"
              [formGroup]="requestFormGroup" formControlNameValue="fiscalPrinters" formGroupNameValue="softwares"
              name="fiscalPrinters" id="fiscalPrinters">
            </app-form-group-number-input-validation>
          </div>
        </div>
        <h4>{{'request-event-modal.hardware' | translate}}</h4>
        <div class="row">
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.phones' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="hardware" formControlNameValue="phones" name="phones"
              id="phones">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.printers' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="hardware" formControlNameValue="printer" name="printer"
              id="printer">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.fiscalPrinters' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="hardware" formControlNameValue="fiscalPrinter" name="fiscalPrinter"
              id="fiscalPrinter">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.routers' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="hardware" formControlNameValue="routers" name="routers"
              id="routers">
            </app-form-group-number-input-validation>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.cable-1m' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="cables" formControlNameValue="one" name="one" id="one">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.cable-5m' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="cables" formControlNameValue="five" name="five"
              id="five">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.cable-10m' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="cables" formControlNameValue="ten" name="ten" id="ten">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.cable-20m' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="cables" formControlNameValue="twenty" name="twenty"
              id="twenty">
            </app-form-group-number-input-validation>
          </div>
          <div class="col">
            <app-form-group-number-input-validation [label]="'request-event-modal.cable-50m' | translate"
              [formGroup]="requestFormGroup" formGroupNameValue="cables" formControlNameValue="fifty" name="fifty"
              id="fifty">
            </app-form-group-number-input-validation>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col text-right">
        <button type="submit" class="btn btn-primary btn-sm">Request</button>
      </div>
    </div>
  </form>
</ng-template>
